import type { CompanyDto } from '@bqcrm/shared';
import { Checkbox, Group, Stack, Switch } from '@mantine/core';

/** Firmy pracownika: domyślnie wszystkie (także dodane później), albo wybrane. */
export function CompaniesField({ companies, all, ids, onChange }: { companies: CompanyDto[]; all: boolean; ids: string[]; onChange: (all: boolean, ids: string[]) => void }) {
  return (
    <Stack gap={6}>
      <Switch
        label="Wszystkie firmy"
        description="Także firmy dodane później. Wyłącz, żeby wskazać wybrane."
        checked={all}
        onChange={(e) => onChange(e.currentTarget.checked, ids)}
      />
      {!all && (
        <Checkbox.Group label="Firmy, w których pracuje" value={ids} onChange={(v) => onChange(false, v)}>
          <Group mt={6}>
            {companies.map((c) => (
              <Checkbox key={c.id} value={c.id} label={c.shortName} />
            ))}
          </Group>
        </Checkbox.Group>
      )}
    </Stack>
  );
}
